import React, { createContext } from 'react';

const TeamMemberGridContext = createContext();

export { TeamMemberGridContext };
